// utils/drawUtils.js
/**
 * Draws a rounded rectangle with fill and stroke.
 * @param {CanvasRenderingContext2D} ctx - Canvas context.
 * @param {number} x - Top-left x.
 * @param {number} y - Top-left y.
 * @param {number} width - Width of the box.
 * @param {number} height - Height of the box.
 * @param {number} radius - Border radius.
 * @param {string} fill - Fill color.
 * @param {string} stroke - Stroke color.
 */
const drawRoundedRect = (ctx, x, y, width, height, radius, fill, stroke) => {
  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.lineTo(x + width - radius, y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
  ctx.lineTo(x + width, y + height - radius);
  ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
  ctx.lineTo(x + radius, y + height);
  ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
  ctx.lineTo(x, y + radius);
  ctx.quadraticCurveTo(x, y, x + radius, y);
  ctx.closePath();

  ctx.fillStyle = fill;
  ctx.fill();
  ctx.strokeStyle = stroke;
  ctx.lineWidth = 2;
  ctx.stroke();
};

/**
 * Draws all drone nest markers on the canvas.
 * @param {CanvasRenderingContext2D} ctx - Canvas rendering context
 * @param {Object[]} droneNests - Array of drone nest items
 * @param {Object} options - Draw options
 */
export const drawDroneNests = (ctx, droneNests, options) => {
  const {
    boxSize,
    borderRadius,
    fontSize,
    backgroundColor,
    borderColor,
    letterColor,
    showOnMap,
    hoveredBoxId,
  } = options;

  ctx.font = `${fontSize}px Arial`;
  ctx.textBaseline = "middle";
  ctx.textAlign = "center";

  droneNests.forEach(({ longitude: x, latitude: y, display_id, id }, index) => {
    const isHovered = hoveredBoxId === id;
    const fillColor =
      showOnMap === id ? "#FF0000" : isHovered ? "#1E90FF" : backgroundColor;
    const boxX = x - boxSize / 2;
    const boxY = y - boxSize / 2;

    drawRoundedRect(
      ctx,
      boxX,
      boxY,
      boxSize,
      boxSize,
      borderRadius,
      fillColor,
      borderColor
    );
    ctx.fillStyle = letterColor;
    ctx.fillText(getLabelCharacter(index, display_id), x, y);
  });
};

export const getLabelCharacter = (index, display_id = null) => {
  if (!!display_id) return display_id;
  let charIndex = index;
  let temp = "";
  if (charIndex >= 26) {
    const divideIndex = Math.floor(charIndex / 26);
    temp += String.fromCharCode(divideIndex - 1 + 65);
    charIndex = charIndex - 26 * divideIndex;
  }

  temp += String.fromCharCode(charIndex + 65);
  return temp;
};
